import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';


const AwardOne = () => {
    return(
        <>
        <section class="award-section section-padding-bottom">
            <div class="default-container">
                <div class="row clearfix">
                    <div class="col-lg-4 order-md-2">
                        <div class="sec-o-title">
                            <h2 class="transform-uppercase">Archived <span>Award</span></h2>
                        </div>
                    </div>
                    <div class="col-lg-8 order-md-1">
                        <OwlCarousel
                        items={4}
                        loop={true}
                        nav={false}
                        dots={true}
                        autoplay={true} class="award-logos section-margin-no four-item-carousel owl-carousel">
                            <img src="images/award/1-01.png" alt="Award" />
                            <img src="images/award/2-01.png" alt="Award" />
                            <img src="images/award/3-01.png" alt="Award" />
                            <img src="images/award/4-01.png" alt="Award" />
                            <img src="images/award/5-01.png" alt="Award" />
                            <img src="images/award/1-01.png" alt="Award" />
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default AwardOne;